import { valibotResolver } from '@hookform/resolvers/valibot';
import { literal, object, variant } from 'valibot';

import StepAIOption from '../components/StepAIOption/StepAIOption';
import StepAIPointSelect from '../components/StepAIPointSelect/StepAIPointSelect';
import StepAIType from '../components/StepAIType/StepAIType';
import StepAIDetails from '../components/StepAiDetails/StepAIDetails';
import {
  ADD_AI_FIELDS,
  schemaAddAiDetails,
  schemaAddAiDetailsWithDate,
  schemaAddAiOption,
  schemaAddAiPointSelect,
  schemaAddAiPointSelectWithEquipmentType,
  schemaAddAiType,
} from '../constants/schemaAddActionItem';

export const getAddAiSteps = () => {
  return [
    {
      step: 1,
      stepComponent: StepAIOption,
      previousStepIndex: 'close',
      nextStepIndex: 1,
      showStepIcon: false,
      schema: valibotResolver(schemaAddAiOption),
    },
    {
      step: 2,
      stepComponent: StepAIType,
      previousStepIndex: 0,
      nextStepIndex: 2,
      showStepIcon: false,
      schema: valibotResolver(schemaAddAiType),
    },
    {
      step: 3,
      stepComponent: StepAIPointSelect,
      previousStepIndex: 1,
      nextStepIndex: 3,
      showStepIcon: true,
      schema: valibotResolver(
        variant(ADD_AI_FIELDS.TYPE, [
          object({
            [ADD_AI_FIELDS.TYPE]: literal('regular'),
            ...schemaAddAiPointSelect.entries,
          }),
          object({
            [ADD_AI_FIELDS.TYPE]: literal('waitesWireless'),
            ...schemaAddAiPointSelectWithEquipmentType.entries,
          }),
        ]),
      ),
    },
    {
      step: 4,
      stepComponent: StepAIDetails,
      previousStepIndex: 2,
      nextStepIndex: 'end',
      showStepIcon: true,
      schema: valibotResolver(
        variant(ADD_AI_FIELDS.OPTION, [

          variant(ADD_AI_FIELDS.TYPE, [
            object({
              [ADD_AI_FIELDS.OPTION]: literal('reportFailure'),
              [ADD_AI_FIELDS.TYPE]: literal('regular'),
              ...schemaAddAiDetailsWithDate.entries,
              ...schemaAddAiPointSelect.entries,
            }),
            object({
              [ADD_AI_FIELDS.OPTION]: literal('reportFailure'),
              [ADD_AI_FIELDS.TYPE]: literal('waitesWireless'),
              ...schemaAddAiDetailsWithDate.entries,
              ...schemaAddAiPointSelectWithEquipmentType.entries,
            }),
          ]),

          variant(ADD_AI_FIELDS.TYPE, [
            object({
              [ADD_AI_FIELDS.OPTION]: literal('requestInvestigation'),
              [ADD_AI_FIELDS.TYPE]: literal('regular'),
              ...schemaAddAiDetails.entries,
              ...schemaAddAiPointSelect.entries,
            }),
            object({
              [ADD_AI_FIELDS.OPTION]: literal('requestInvestigation'),
              [ADD_AI_FIELDS.TYPE]: literal('waitesWireless'),
              ...schemaAddAiDetails.entries,
              ...schemaAddAiPointSelectWithEquipmentType.entries,
            }),
          ]),
        ]),
      ),
    },
  ];
};
